import merge from 'lodash/merge';
import { TFunction } from 'i18next';

import { getDefaultDlpConfig, getDlpTemplateConfig } from './cfg.dlp.default'; //   getTargetProperty,
import cloneDeep from 'lodash/cloneDeep';

import {
  ActionEnum,
  KfContainRule,
  KfContainTypeEnum,
  KfDefaultLogicalOperatorEnum,
  KfFileTypeEnum,
} from '@Policy/utils/types';

const cfg = {
  policyType: 4,
  policySubType: 0,
  holderType: 2,
  tmKeywordfilters: {
    kfCollaborationActionType: 103,
    kfCollaborationNotifyType: 0,
    kfContainRules: [],
    kfContainType: 0,
    kfEnabled: 0,
    kfNonCollaborationActionType: 103,
    kfNonCollaborationNotifyType: 0,
    kfReplacementText:
      'This file is %Action% because it triggered %FilterName%.\r\nContact your Cloud App Security administrator for further support or information.',
    notification: {
      ntfAdminIntervalNum: 2,
      ntfAdminIntervalType: 0,
      ntfAdminMessage:
        'Cloud App Security detected a file that triggered Keyword Extraction policy violation.\r\n\r\nAction taken: %action%\r\nMessage details:\r\n\tLast modified time: %date% %time%\r\n\tFound in: %foundin%\r\n\tTriggered policy: %policy_name%\r\n\tFile name: %filename%\r\n\tAffected User: %violator%\r\n\tViolated keyword: %violated_keyword%\r\n\r\n',
      ntfAdminNotifySettingType: 0,
      ntfAdminOccurenceNum: 50,
      ntfAdminSubject: 'Trend Micro Cloud App Security Keyword Extraction',
      ntfDoNotNotifyExternalUser: 0,
      ntfEnableEndUserRestore: 0,
      ntfEnableNotifyAdmin: 1,
      ntfEnableNotifyRecipient: 0,
      ntfInternalRecipientMessage:
        'Cloud App Security detected a file that triggered Keyword Extraction policy violation, and took action on it to comply with the information security policies of the organization.\r\n\r\nAction taken: %action%\r\nMessage details:\r\n\tFound in: %foundin%\r\n\tTriggered policy: %policy_name%\r\n\tAffected User: %violator%\r\n\tViolated keyword: %violated_keyword%\r\n\r\n',
      ntfInternalRecipientSubject:
        'Trend Micro Cloud App Security Keyword Extraction',
      ntfRecipientGroupEnabled: 1,
      ntfRecipientGroupId: 1,
      ntfToAccount: '',
    },
  },
};

export function getDlpBoxTemplateConfig(
  t: TFunction<'translation'>,
  accountEmail: string | undefined
) {
  const ntfI18nReplaceKeys = [
    'policy.policyTemplate.BOX.tmKeywordfilters.notification.ntfAdminMessage',
    'policy.policyTemplate.BOX.tmKeywordfilters.notification.ntfAdminSubject',
    'policy.policyTemplate.BOX.tmKeywordfilters.notification.ntfInternalRecipientMessage',
    'policy.policyTemplate.BOX.tmKeywordfilters.notification.ntfInternalRecipientSubject',
    'policy.policyTemplate.BOX.tmSlfFilters.notification.ntfAdminMessage',
    'policy.policyTemplate.BOX.tmSlfFilters.notification.ntfAdminSubject',
    'policy.policyTemplate.BOX.tmSlfFilters.notification.ntfInternalRecipientMessage',
    'policy.policyTemplate.BOX.tmSlfFilters.notification.ntfInternalRecipientSubject',
  ];
  const tempConfig = getDefaultDlpConfig();
  merge(tempConfig, cfg);
  return getDlpTemplateConfig(
    t,
    tempConfig,
    accountEmail,
    [],
    ntfI18nReplaceKeys
  );
}

const emptyRule: KfContainRule = {
  kfFileType: KfFileTypeEnum.Text,
  kfContainType: KfContainTypeEnum.Contain,
  tmKeywords: [],
  kfDefaultLogicalOperator: KfDefaultLogicalOperatorEnum.Or,
  kfCollaborationActionType: `${ActionEnum.delete}`,
  kfNonCollaborationActionType: `${ActionEnum.pass}`,
};

export const getEmptyRule = () => {
  return cloneDeep(emptyRule);
};
